<script>
    import {onMount} from "svelte"
    import {files, api} from "../../store"
    

    let file_path, api_url
    api.subscribe(value => (api_url = value))
    files.subscribe(value => (file_path = value))
    

    const urlParams = new URLSearchParams(window.location.search);
    const id = urlParams.get("id");
    let result = false

    function getResult() {
        let query = new FormData()
        query.append("getsingle", "true")
        query.append("id", id)


        fetch(`${api_url}matrimonial.php`, {
        method: "POST",
        body: query 
        })
        .then(res => res.json())
        .then(res => {
            result = res.data
        })
    }

    function checkEmpty (data) {

      return data?data:("<strong>NIL<strong>")
  
    }

    onMount(()=>getResult())


</script>

{#if result}
<div class="ds-form-title text-center p-5" >
    <h1>Welcome to 
      <strong>
        {`${result.full_name[0].toUpperCase()}${result.full_name.substring(0)}`}'s
      </strong> 
      Profile</h1>

 </div>
<div class="ds-container">
    <div class="photos">
        <div class="img">
            <h2 for="photo">Photo</h2>
            <img src={`${file_path}${result.photo}`} alt="">
        </div>
        <div class="horo">
            <h2 for="photo">Horoscope</h2>
            <img src={`${file_path}${result.horoscope}`} alt="">
        </div>
    </div>

    <div class="ds-table">
        <table class="table">
  
            <tbody>
              <tr>
                <th scope="row">Gender</th>
                <td>{result.gender}</td>
              </tr>
           
              <tr>
                <th scope="row">Full Name</th>
                <td>{result.full_name}</td>
              </tr>
              
              <tr>
                <th scope="row">Current Address</th>
                <td>
                    {result.current_address_address} <br/>
                    {result.current_address_city} <br/>
                    {result.current_address_state} <br/>
                    {result.current_address_country} <br/>
                    {result.current_address_zip_code} <br/>
                </td>
              </tr>
    
              <tr>
                <th scope="row">Native Address</th>
                <td>
                    {result.native_address_address} <br/>
                    {result.native_address_city} <br/>
                    {result.native_address_state} <br/>
                    {result.native_address_country} <br/>
                    {result.native_address_zip_code} <br/>
                </td>
              </tr>
    
              <tr>
                <th scope="row">Contact</th>
                <td>{@html checkEmpty(result.contact)}</td>
              </tr>
              <tr>
                <th scope="row">Email</th>
                <td>{@html checkEmpty(result.email)}</td>
              </tr>
              <tr>
                <th scope="row">Education</th>
                <td>{@html checkEmpty(result.education)}</td>
              </tr>
              <tr>
                <th scope="row">Working</th>
                <td>{@html checkEmpty(result.working)}</td>
              </tr>
    
              {#if result.working == "yes" }
              <tr>
                <th scope="row">Work Location</th>
                <td>{@html checkEmpty(result.work_location)}</td>
              </tr>
    
              <tr>
                <th scope="row">Salary</th>
                <td>{@html checkEmpty(result.salary)}</td>
              </tr>
              {/if}
                  
              <tr>
                <th scope="row">Zodiac Star</th>
                <td>{@html checkEmpty(result.zodiac_star)}</td>
              </tr>
           
              <tr>
                <th scope="row">Caste</th>
                <td>{result.caste }</td>
              </tr>
              <tr>
                <th scope="row">Division</th>
                <td>{result.division}</td>
              </tr>
              <tr>
                <th scope="row">Sub Division</th>
                <td>{result.sub_division}</td>
              </tr>
              <tr>
                <th scope="row">Special Mention</th>
                <td>{@html checkEmpty(result.special_mention)}</td>
              </tr>
              <tr>
                <th scope="row">Contact Person</th>
                <td>
                    <strong>{result.contact_person}</strong> <br/>
                    {result.contact_person_phone} <br/>
                    {result.contact_person_email}
                </td>
              </tr>
           
           
            </tbody>
          </table>
    </div>
    
    
</div>
{/if}
  
  
  
  
  
  

  
  
  







<style lang="scss">
    @import "../scss//Config.scss";

    .ds-container{
        width: 80%;
        margin: auto;
        display: grid;
        grid-template-columns: 0.5fr 1fr;
        @include mobile{
            grid-template-columns: 1fr;
        }

        .photos {
            display: grid;
            grid-template-columns: 1fr;
            
            div{
                padding: 5%;
                img {
                    width: 100%;
                }
            }
        }

       
    }
    .ds-table {
        padding: 5% !important;

        * {
            border: 1px solid #000;
        }
    }

    strong {
            color: red;
            border: none !important;
        }
</style>


